import { getFileInfo, uploadFile } from '../../../api/mediaPlatform';
import biLogger from '../../../lib/bi/biLogger';
import localFiles from '../../../lib/localMediaFiles';
import { MediaType } from '../../../types/media';
import { Thunk } from '../../rootReducer';
import { MEDIA_SELECTION_LIMIT } from '../constants';
import { getSelectedMediaCount } from '../selectors';
import * as actions from './actions';
import getFileImagePreview from './getFileImagePreview';
import getMPImagePreview from './getMPImagePreview';
import loadImage from './loadImage';
import { UploadActions } from './reducer';
import { uploadFinish, uploadStart } from '@wix/bi-logger-vmaf/v2';

function upload(files: FileList): Thunk<UploadActions> {
  return (dispatch, getState) => {
    localFiles.register(files);

    dispatch(actions.clanUpFailed());

    Array.from(files).forEach(async (file) => {
      const fileInfo = getFileInfo(file);
      const biCorrelationId = fileInfo.name;
      const selectedCount = getSelectedMediaCount(getState());
      const { name, url } = fileInfo;
      dispatch(
        actions.upload.request({
          ...fileInfo,
          selected: selectedCount < MEDIA_SELECTION_LIMIT,
        }),
      );

      if (fileInfo.type === MediaType.IMAGE) {
        void getFileImagePreview(file).then((previewUrl: string) => {
          dispatch(actions.setPreviewImage({ url: previewUrl, name }));
        });
      }
      void biLogger.report(uploadStart({ correlationId: biCorrelationId }));

      try {
        await uploadFile(fileInfo, file, {
          // onProgress: progress => {
          //   dispatch(actions.progress({ ...fileInfo, progress }));
          // },
        });

        if (fileInfo.type === MediaType.IMAGE) {
          const previewImageMP = getMPImagePreview(url);

          void loadImage(previewImageMP).then(() => {
            dispatch(actions.setPreviewImage({ url: previewImageMP, name }));
          });
        }

        dispatch(actions.upload.success({ ...fileInfo }));

        void biLogger.report(
          uploadFinish({
            correlationId: biCorrelationId,
            mediaType: file.type,
            success: true,
          }),
        );
      } catch (error) {
        dispatch(
          actions.upload.failure({ ...fileInfo, error, selected: false }),
        );

        void biLogger.report(
          uploadFinish({
            correlationId: biCorrelationId,
            mediaType: file.type,
            success: false,
            errorReason: JSON.stringify(error),
          }),
        );
      }
    });
  };
}

export { upload };
